// extracted by mini-css-extract-plugin
export default {"labels":"labelWithHR_labels__Es5rP","labelsMobile":"labelWithHR_labelsMobile__CbAPj","hr":"labelWithHR_hr__oc2WS","hrMobile":"labelWithHR_hrMobile__2OQYq"};